export default `<div class="list-loader">
    <div class="loader"><div class="lds-ring"><div></div><div></div><div></div><div></div></div></div>
</div>
`;